import { ProductGroupDTO } from '../../dto/mg/ProductGroupDTO';

interface Props {
  name: string;
  groupNumber: string;
}

export class ProductGroupBase {
  name: string;
  groupNumber: string;

  constructor({ name, groupNumber }: Props) {
    this.name = name;
    this.groupNumber = groupNumber;
  }

  getLabel = (): string => `${this.groupNumber} ${this.name}`;

  static fromDto = (dto: ProductGroupDTO): ProductGroupBase =>
    new ProductGroupBase({
      name: dto.name,
      groupNumber: dto.groupNumber,
    });
}
